<template>
  <div>
    <div v-if="pageLoading" class="text-center" style="padding: 80px 0;">
      <div class="spinner-border text-primary" role="status">
        <span class="sr-only">Carregando...</span>
      </div>
      <p class="mt-2">Carregando...</p>
    </div>
    <div class="main-content" v-else>
      <div class="row">
        <div class="col-md-12">
          <div class="card">
            <div class="card-header">
              <div class="card-title">Nova Movimentação</div>
            </div>
            <hr style="margin-top: -4px" />
            <div class="col-md-12">
              <form action @submit.prevent>
                <div class="form-row">
                  <div class="form-group col-md-4">
                    <label>Patrimônio:</label>
                    <div class="input-group">
                      <div class="input-group-prepend">
                        <span class="input-group-text">PAT-</span>
                      </div>
                      <input
                        type="tel"
                        class="form-control"
                        v-model="patrimonioSuffix"
                        placeholder="000123"
                        @keyup.enter="findProductByBarcode"
                      />
                      <div class="input-group-append">
                        <button
                          type="button"
                          class="btn btn-outline-primary"
                          title="Pesquisar"
                          @click="findProductByBarcode"
                        >
                          <i class="fa fa-search"></i>
                        </button>
                        <button type="button" class="btn btn-outline-secondary" title="Escanear com a câmera" @click="openScanner">
                          <i class="fa fa-camera"></i>
                        </button>
                      </div>
                    </div>
                  </div>
                  <div class="form-group col-md-3 d-flex align-items-end">
                    <button type="button" class="btn btn-outline-secondary" @click="openProductPicker">
                      <i class="fa fa-list"></i> Ver produtos em estoque
                    </button>
                  </div>
                </div>

                <div class="form-row preview-row" v-if="selectedProduct">
                  <div class="form-group col-md-3">
                    <label>Modelo:</label>
                    <p class="preview-text">{{ selectedProduct.product_model ? selectedProduct.product_model.name : "-" }}</p>
                  </div>
                  <div class="form-group col-md-3">
                    <label>Fabricante:</label>
                    <p class="preview-text">{{ selectedProduct.manufacturer ? selectedProduct.manufacturer.name : "-" }}</p>
                  </div>
                  <div class="form-group col-md-3">
                    <label>Fornecedor:</label>
                    <p class="preview-text">{{ selectedProduct.supplier ? selectedProduct.supplier.name : "-" }}</p>
                  </div>
                  <div class="form-group col-md-3">
                    <label>Unidade atual:</label>
                    <p class="preview-text">{{ selectedProductLocationLabel }}</p>
                  </div>

                  <div class="form-group col-md-12">
                    <button
                      type="button"
                      class="btn btn-status-toggle"
                      :class="{ active: statusOnlyMode }"
                      @click="statusOnlyMode = !statusOnlyMode"
                    >
                      <i class="fa" :class="statusOnlyMode ? 'fa-toggle-on' : 'fa-toggle-off'"></i>
                      Somente alterar status (produto permanece na mesma unidade)
                    </button>
                  </div>

                  <template v-if="!statusOnlyMode">
                    <div class="form-group col-md-4">
                      <label>
                        <span class="required">*</span> Cliente Destino:
                      </label>
                      <v-select
                        v-model="itemClientId"
                        :options="clients"
                        :reduce="(clients) => clients.id"
                        :label="'company_name'"
                        @input="onItemClientChange"
                      ></v-select>
                    </div>
                    <div class="form-group col-md-4">
                      <label>
                        <span class="required">*</span> Unidade Destino:
                      </label>
                      <v-select
                        v-model="itemUnitId"
                        :options="filteredItemUnits"
                        :reduce="(units) => units.id"
                        :label="'name'"
                      ></v-select>
                    </div>
                    <div class="form-group col-md-4">
                      <label>Novo Status (opcional):</label>
                      <select v-model="itemNewStatus" class="form-control">
                        <option value="">Manter status atual</option>
                        <option :value="1">Em estoque</option>
                        <option :value="2">Em uso</option>
                        <option :value="3">Manutenção</option>
                        <option :value="0">Baixado</option>
                      </select>
                    </div>
                  </template>
                  <div class="form-group col-md-4" v-else>
                    <label>
                      <span class="required">*</span> Novo Status:
                    </label>
                    <select v-model="itemNewStatus" class="form-control">
                      <option value="" disabled>Selecione o novo status</option>
                      <option :value="1">Em estoque</option>
                      <option :value="2">Em uso</option>
                      <option :value="3">Manutenção</option>
                      <option :value="0">Baixado</option>
                    </select>
                  </div>

                  <div class="form-group col-md-12 text-right">
                    <a
                      class="btn btn-add"
                      :class="{ disabled: !canAddItem }"
                      @click="addItem"
                    >
                      <i class="fa fa-plus"></i> Adicionar
                    </a>
                  </div>
                </div>

                <div class="form-row">
                  <div class="form-group col-md-12">
                    <label>Observação:</label>
                    <textarea
                      class="form-control"
                      v-model="movement.notes"
                      rows="3"
                    ></textarea>
                  </div>
                </div>        

                <span class="required_fields">
                  <span class="required">*</span>
                  <strong>Campos obrigatórios</strong>
                </span>

                <div class="form-row" v-if="itemsToMove.length">
                  <div class="form-group col-md-12">
                    <table class="table table-striped table-bordered crud-table">
                      <thead>
                        <tr>
                          <th>Modelo</th>
                          <th>Fabricante</th>
                          <th>Fornecedor</th>
                          <th>Unidade Atual</th>
                          <th>Unidade Destino</th>
                          <th>Novo Status</th>
                          <th>Ações</th>
                        </tr>
                      </thead>
                      <tbody>
                        <tr v-for="(item, index) in itemsToMove" :key="item.product_id">
                          <td>{{ item.product_model_name }}</td>
                          <td>{{ item.manufacturer_name }}</td>
                          <td>{{ item.supplier_name }}</td>
                          <td>{{ item.current_location_label }}</td>
                          <td>
                            <span v-if="item.status_only" class="text-muted">Sem alteração (só status)</span>
                            <span v-else>{{ item.to_client_name }} / {{ item.to_unit_name }}</span>
                          </td>
                          <td class="text-center">
                            <span v-if="item.new_status !== ''" class="soft-badge" :class="statusBadgeClass(item.new_status)">
                              {{ statusLabel(item.new_status) }}
                            </span>
                            <span v-else class="text-muted">Manter status atual</span>
                          </td>
                          <td>
                            <button
                              type="button"
                              class="btn btn-crud delete"
                              title="Remover"
                              @click="removeItem(index)"
                            >
                              <i class="far fa-trash-alt"></i>
                            </button>
                          </td>
                        </tr>
                      </tbody>
                    </table>
                  </div>
                </div>

                <div class="block text-right mb-1">
                  <router-link to="/stock_movements" class="btn btn-back">
                    <i class="fa fa-arrow-left"></i> Voltar
                  </router-link>
                  <a class="btn btn-add ml-1" @click="save">
                    Salvar
                    <i class="fa fa-save"></i>
                  </a>
                </div>

              </form>
            </div>
          </div>
        </div>
      </div>
    </div>

     <!-- Modal de seleção de produto em estoque -->
    <div class="modal fade" id="productPickerModal" tabindex="-1" role="dialog" aria-hidden="true">
      <div class="modal-dialog modal-lg modal-dialog-centered" role="document">
        <div class="modal-content">
          <div class="modal-header">
            <h5 class="modal-title">Produtos em Estoque</h5>
            <button type="button" class="close" data-dismiss="modal" aria-label="Close">
              <span aria-hidden="true">&times;</span>
            </button>
          </div>
          <div class="modal-body">
            <input
              type="text"
              class="form-control mb-3"
              v-model="productPickerSearch"
              placeholder="Buscar por patrimônio, modelo ou fabricante..."
            />
            <div class="table-responsive">
              <table class="table table-striped table-bordered crud-table">
                <thead>
                  <tr>
                    <th>Patrimônio</th>
                    <th>Modelo</th>
                    <th>Fabricante</th>
                    <th>Fornecedor</th>
                    <th>Unidade Atual</th>
                    <th>Status</th>
                  </tr>
                </thead>
                <tbody>
                  <tr v-if="!filteredPickerProducts.length">
                    <td colspan="6" class="text-center py-3">Nenhum produto encontrado</td>
                  </tr>
                  <tr
                    v-for="p in filteredPickerProducts"
                    :key="p.id"
                    class="picker-row"
                    @click="selectProductFromPicker(p)"
                  >
                    <td data-label="Patrimônio">{{ p.barcode || "-" }}</td>
                    <td data-label="Modelo">{{ p.product_model ? p.product_model.name : "-" }}</td>
                    <td data-label="Fabricante">{{ p.manufacturer ? p.manufacturer.name : "-" }}</td>
                    <td data-label="Fornecedor">{{ p.supplier ? p.supplier.name : "-" }}</td>
                    <td data-label="Unidade Atual">{{ locationLabel(p.current_client_id, p.current_unit_id) }}</td>
                    <td data-label="Status" class="text-center">
                      <span class="soft-badge" :class="statusBadgeClass(p.status)">
                        {{ statusLabel(p.status) }}
                      </span>
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>
          <div class="modal-footer d-flex justify-content-between align-items-center">
            <strong>Total de produtos: {{ filteredPickerProducts.length }}</strong>
            <button type="button" class="btn btn-secondary" data-dismiss="modal">Fechar</button>
          </div>
        </div>
      </div>
    </div>

    <div
      class="modal fade"
      id="barcodeScannerModal"
      tabindex="-1"
      role="dialog"
      aria-hidden="true"
      data-backdrop="static"
    >
      <div class="modal-dialog modal-dialog-centered" role="document">
        <div class="modal-content">
          <div class="modal-header">
            <h5 class="modal-title">Escanear Patrimônio</h5>
            <button type="button" class="close" data-dismiss="modal" @click="closeScanner">
              <span aria-hidden="true">&times;</span>
            </button>
          </div>
          <div class="modal-body">
            <div id="barcode-scanner-viewport" v-show="!useZxingScanner"></div>
            <video
              id="zxing-scanner-viewport"
              v-show="useZxingScanner"
              class="zxing-scanner-viewport"
              playsinline
              muted
              autoplay
            ></video>
            <p class="text-muted text-center mt-2 mb-0">
              Aproxime a câmera do código de barras do patrimônio e mantenha firme até focar.
            </p>
            <p v-if="scannerError" class="text-danger text-center mt-2 mb-0">{{ scannerError }}</p>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import vSelect from "vue-select";
import { Html5Qrcode, Html5QrcodeSupportedFormats, Html5QrcodeScannerState } from "html5-qrcode";
import { BrowserMultiFormatReader, DecodeHintType, BarcodeFormat, NotFoundException } from "@zxing/library";

function hasNativeBarcodeDetector() {
  if (typeof window === "undefined" || !("BarcodeDetector" in window)) {
    return false;
  }
  try {
    const detector = new window.BarcodeDetector({ formats: ["code_128"] });
    return !!detector;
  } catch (e) {
    return false;
  }
}

export default {
  name: "stockMovementAdd",
  data() {
    return {
      pageLoading: true,
      patrimonioSuffix: "",
      selectedProductId: "",
      productPickerSearch: "",
      scannerError: "",
      html5QrCode: null,
      useZxingScanner: false,
      zxingReader: null,
      zxingVideoElement: null,
      itemClientId: "",
      itemUnitId: "",
      itemNewStatus: "",
      statusOnlyMode: false,
      itemsToMove: [],
      movement: {
        notes: "",
      },
      products: [],
      clients: [],
      units: [],
    };
  },
  components: {
    vSelect,
  },
  computed: {
    selectedProduct: function () {
      const self = this;
      return self.products.find((p) => p.id == self.selectedProductId);
    },
    selectedProductLocationLabel: function () {
      const self = this;
      const product = self.selectedProduct;
      if (!product) return "";
      return self.locationLabel(product.current_client_id, product.current_unit_id);
    },
    filteredItemUnits: function () {
      const self = this;
      if (!self.itemClientId) return [];
      return self.units.filter((u) => u.client_id == self.itemClientId);
    },
    canAddItem: function () {
      const self = this;
      if (!self.selectedProductId) return false;
      if (self.statusOnlyMode) {
        return self.itemNewStatus !== "" && self.itemNewStatus !== null;
      }
      return !!self.itemUnitId;
    },
    filteredPickerProducts: function () {
      const self = this;
      const term = self.productPickerSearch.trim().toLowerCase();
      if (!term) return self.products;

      return self.products.filter((p) => {
        const barcode = (p.barcode || "").toLowerCase();
        const modelName = (p.product_model ? p.product_model.name : "").toLowerCase();
        const manufacturerName = (p.manufacturer ? p.manufacturer.name : "").toLowerCase();
        return (
          barcode.includes(term) ||
          modelName.includes(term) ||
          manufacturerName.includes(term)
        );
      });
    },
  },
  methods: {
    locationLabel: function (clientId, unitId) {
      const self = this;
      if (!clientId && !unitId) {
        return "Nenhuma (produto ainda não foi movimentado)";
      }

      const client = self.clients.find((c) => c.id == clientId);
      const unit = self.units.find((u) => u.id == unitId);

      return (
        (client ? client.company_name : "?") + " / " + (unit ? unit.name : "?")
      );
    },
    onItemClientChange: function () {
      this.itemUnitId = "";
    },
    statusLabel: function (status) {
      const labels = { 1: "Em estoque", 2: "Em uso", 3: "Manutenção", 0: "Baixado" };
      return labels[status] ?? "Baixado";
    },
    statusBadgeClass: function (status) {
      const classes = {
        1: "badge-success",
        2: "badge-primary",
        3: "badge-warning",
        0: "badge-danger",
      };
      return classes[status] ?? "badge-secondary";
    },
    openProductPicker: function () {
      this.productPickerSearch = "";
      $("#productPickerModal").modal("show");
    },
    selectProductFromPicker: function (p) {
      const self = this;
      self.selectedProductId = p.id;
      self.patrimonioSuffix = (p.barcode || "").replace(/^PAT-/, "");
      $("#productPickerModal").modal("hide");
    },
    findProductByBarcode: function () {
      const self = this;
      const barcode = "PAT-" + self.patrimonioSuffix;
      const found = self.products.find((p) => p.barcode === barcode);

      if (!found) {
        self.$message(null, "Produto não encontrado com esse patrimônio", "error");
        return;
      }

      self.selectedProductId = found.id;
    },

    openScanner: function () {
      const self = this;
      self.scannerError = "";
      self.useZxingScanner = !hasNativeBarcodeDetector();

      $("#barcodeScannerModal").modal("show");

      self.$nextTick(() => {
        if (self.useZxingScanner) {
          self.startZxingScanner();
        } else {
          self.startHtml5QrcodeScanner();
        }
      });

      $("#barcodeScannerModal").off("hidden.bs.modal").on("hidden.bs.modal", function () {
        self.pauseScanner();
      });
    },

    startHtml5QrcodeScanner: function () {
      const self = this;

      if (self.html5QrCode) {
        const state = self.html5QrCode.getState();
        if (state === Html5QrcodeScannerState.PAUSED) {
          self.html5QrCode.resume();
          self.applyHtml5QrcodeAutoZoom();
          return;
        }
        if (state === Html5QrcodeScannerState.SCANNING) {
          self.applyHtml5QrcodeAutoZoom();
          return;
        }
        self.html5QrCode = null;
      }

      self.html5QrCode = new Html5Qrcode("barcode-scanner-viewport", {
        formatsToSupport: [
          Html5QrcodeSupportedFormats.CODE_128,
          Html5QrcodeSupportedFormats.EAN_13,
          Html5QrcodeSupportedFormats.EAN_8,
          Html5QrcodeSupportedFormats.UPC_A,
        ],
        useBarCodeDetectorIfSupported: true,
        verbose: false,
      });

      self.html5QrCode
        .start(
          { facingMode: "environment" },
          {
            fps: 15,
            qrbox: { width: 300, height: 120 },
            disableFlip: true,
            videoConstraints: {
              facingMode: "environment",
              width: { ideal: 1920 },
              height: { ideal: 1080 },
            },
          },
          (decodedText) => self.onScanSuccess(decodedText),
          () => {}
        )
        .then(() => {
          if (self.html5QrCode) {
            self.html5QrCode
              .applyVideoConstraints({ advanced: [{ focusMode: "continuous" }] })
              .catch(() => {});
          }
          self.applyHtml5QrcodeAutoZoom();
        })
        .catch((err) => {
          self.scannerError = "Não foi possível acessar a câmera: " + err;
        });
    },

    applyHtml5QrcodeAutoZoom: function () {
      const self = this;
      if (!self.html5QrCode) return;
      try {
        const zoom = self.html5QrCode.getRunningTrackCameraCapabilities().zoomFeature();
        if (zoom.isSupported()) {
          const target = zoom.min() + (zoom.max() - zoom.min()) * 0.35;
          zoom.apply(target).catch(() => {});
        }
      } catch (e) {}
    },

    startZxingScanner: function () {
      const self = this;

      if (self.zxingReader && self.zxingVideoElement && self.zxingVideoElement.srcObject) {
        self.zxingReader.decodeContinuously(self.zxingVideoElement, (result, err) =>
          self.handleZxingResult(result, err)
        );
        self.applyZxingAutoZoom();
        return;
      }

      const hints = new Map();
      hints.set(DecodeHintType.POSSIBLE_FORMATS, [
        BarcodeFormat.CODE_128,
        BarcodeFormat.EAN_13,
        BarcodeFormat.EAN_8,
        BarcodeFormat.UPC_A,
      ]);
      hints.set(DecodeHintType.TRY_HARDER, true);

      self.zxingReader = new BrowserMultiFormatReader(hints);

      self.zxingReader
        .decodeFromConstraints(
          {
            audio: false,
            video: {
              facingMode: "environment",
              width: { ideal: 1920 },
              height: { ideal: 1080 },
            },
          },
          "zxing-scanner-viewport",
          (result, err) => self.handleZxingResult(result, err)
        )
        .then(() => {
          self.zxingVideoElement = document.getElementById("zxing-scanner-viewport");
          self.applyZxingAutoZoom();
        })
        .catch((err) => {
          self.scannerError = "Não foi possível acessar a câmera: " + err;
        });
    },

    handleZxingResult: function (result, err) {
      const self = this;
      if (result) {
        self.onScanSuccess(result.getText());
        return;
      }
      if (err && !(err instanceof NotFoundException)) {
        self.scannerError = "Erro ao ler o código de barras: " + err;
      }
    },

    applyZxingAutoZoom: function () {
      const self = this;
      if (!self.zxingReader || !self.zxingReader.stream) return;
      const track = self.zxingReader.stream.getVideoTracks()[0];
      if (!track || typeof track.getCapabilities !== "function") return;
      try {
        const capabilities = track.getCapabilities();
        if (!capabilities.zoom) return;
        const target = capabilities.zoom.min + (capabilities.zoom.max - capabilities.zoom.min) * 0.35;
        track.applyConstraints({ advanced: [{ zoom: target }] }).catch(() => {});
      } catch (e) {}
    },

    onScanSuccess: function (decodedText) {
      const self = this;
      const value = (decodedText || "").trim().replace(/^PAT-/i, "");
      self.patrimonioSuffix = value;
      self.closeScanner();
      self.findProductByBarcode();
    },

    pauseScanner: function () {
      const self = this;
      if (self.html5QrCode && self.html5QrCode.getState() === Html5QrcodeScannerState.SCANNING) {
        self.html5QrCode.pause(true);
      }
      if (self.zxingReader) {
        self.zxingReader.stopContinuousDecode();
      }
    },

    stopScanner: function () {
      const self = this;
      if (self.html5QrCode) {
        self.html5QrCode
          .stop()
          .then(() => self.html5QrCode.clear())
          .catch(() => {});
        self.html5QrCode = null;
      }
      if (self.zxingReader) {
        self.zxingReader.reset();
        self.zxingReader = null;
        self.zxingVideoElement = null;
      }
    },

    closeScanner: function () {
      $("#barcodeScannerModal").modal("hide");
      this.pauseScanner();
    },

    addItem: function () {
      const self = this;
      if (!self.selectedProductId) return;

      const product = self.selectedProduct;
      if (!product) return;

      let clientId;
      let unitId;

      if (self.statusOnlyMode) {
        if (self.itemNewStatus === "" || self.itemNewStatus === null) {
          self.$message(null, "Selecione o novo status do produto", "error");
          return;
        }
        if (!product.current_client_id || !product.current_unit_id) {
          self.$message(
            null,
            "Esse produto ainda não tem unidade atual definida, então não é possível usar o modo somente status",
            "error"
          );
          return;
        }
        clientId = product.current_client_id;
        unitId = product.current_unit_id;
      } else {
        if (!self.itemUnitId) return;
        clientId = self.itemClientId;
        unitId = self.itemUnitId;
      }

      if (self.itemsToMove.some((i) => i.product_id == self.selectedProductId)) {
        self.$message(null, "Esse produto já foi adicionado à lista", "error");
        return;
      }

      const client = self.clients.find((c) => c.id == clientId);
      const unit = self.units.find((u) => u.id == unitId);

      self.itemsToMove.push({
        product_id: product.id,
        product_model_name: product.product_model ? product.product_model.name : "-",
        manufacturer_name: product.manufacturer ? product.manufacturer.name : "-",
        supplier_name: product.supplier ? product.supplier.name : "-",
        current_location_label: self.locationLabel(product.current_client_id, product.current_unit_id),
        to_client_id: clientId,
        to_client_name: client ? client.company_name : "?",
        to_unit_id: unitId,
        to_unit_name: unit ? unit.name : "?",
        new_status: self.itemNewStatus,
        status_only: self.statusOnlyMode,
      });

      self.selectedProductId = "";
      self.patrimonioSuffix = "";
      self.itemClientId = "";
      self.itemUnitId = "";
      self.itemNewStatus = "";
    },
    removeItem: function (index) {
      this.itemsToMove.splice(index, 1);
    },
    getProducts: function () {
      const self = this;
      return axios
        .get(
          self.$store.state.api +
            "products/?status[]=1&status[]=2&status[]=3&with[]=manufacturer&with[]=productModel&with[]=supplier"
        )
        .then((response) => {
          self.products = response.data.data;
        })
        .catch((error) => {
          self.$message(null, error.response.data, "error");
        });
    },
    getClients: function () {
      const self = this;
      return axios
        .get(self.$store.state.api + "clients/?status=1")
        .then((response) => {
          self.clients = response.data.data;
        })
        .catch((error) => {
          self.$message(null, error.response.data, "error");
        });
    },
    getUnits: function () {
      const self = this;
      return axios
        .get(self.$store.state.api + "client_units/?status=1&paginated=false")
        .then((response) => {
          self.units = response.data.data;
        })
        .catch((error) => {
          self.$message(null, error.response.data, "error");
        });
    },
    save: function () {
      const self = this;

      if (!self.itemsToMove.length) {
        self.$message(null, "Adicione pelo menos um produto antes de salvar", "error");
        return;
      }

      const requests = self.itemsToMove.map((item) => {
        const payload = {
          product_id: item.product_id,
          to_client_id: item.to_client_id,
          to_unit_id: item.to_unit_id,
          notes: self.movement.notes,
        };

        if (item.new_status !== "" && item.new_status !== null) {
          payload.new_status = item.new_status;
        }

        return axios.post(self.$store.state.api + "stock_movements", payload);
      });

      Promise.all(requests)
        .then(() => {
          self.$message(
            "Sucesso",
            "Movimentação registrada com sucesso",
            "success"
          );
          self.$router.push("/stock_movements");
        })
        .catch((error) => {
          self.$message(null, error.response.data, "error");
        });
    },
  },
  beforeDestroy() {
    this.stopScanner();
  },
  async mounted() {
    const self = this;
    self.pageLoading = true;

    try {
      await Promise.all([
        self.getProducts(),
        self.getClients(),
        self.getUnits(),
      ]);
    } catch (e) {
      console.error(e);
    } finally {
      self.pageLoading = false;
    }
  },
};
</script>
<style scoped>
.preview-row {
  background: rgba(255, 255, 255, 0.03);
  border-radius: 6px;
  padding: 12px 4px 0;
  margin-bottom: 1rem;
}

.preview-text {
  margin-bottom: 0;
}

.btn-add.disabled {
  opacity: 0.5;
  pointer-events: none;
}

.btn-status-toggle {
  display: inline-flex;
  align-items: center;
  gap: 8px;
  background: rgba(255, 255, 255, 0.04);
  border: 1px solid rgba(255, 255, 255, 0.15);
  color: inherit;
  border-radius: 6px;
  padding: 8px 14px;
  margin-bottom: 1rem;
}

.btn-status-toggle i {
  font-size: 1.1rem;
  color: rgba(255, 255, 255, 0.4);
}

.btn-status-toggle.active {
  background: rgba(115, 103, 240, 0.12);
  border-color: rgba(115, 103, 240, 0.4);
  color: #8b82df;
}

.btn-status-toggle.active i {
  color: #8b82df;
}

body:not(.dark-layout) .btn-status-toggle {
  background: rgba(0, 0, 0, 0.03);
  border-color: rgba(0, 0, 0, 0.15);
}

.crud-table {
  margin-bottom: 0;
  font-size: 0.95rem;
  width: 100%;
}

.crud-table td,
.crud-table th {
  padding: 0.9rem 0.75rem;
  white-space: normal;
  overflow-wrap: break-word;
}

.crud-table thead th {
  background-color: #283046 !important;
  padding-top: 0.7rem;
  padding-bottom: 0.7rem;
  vertical-align: middle;
  border-left: none !important;
  border-right: none !important;
  font-size: 0.80rem;
}

.crud-table tbody tr,
.crud-table tbody tr:nth-of-type(odd),
.crud-table tbody tr:nth-of-type(even) {
  background-color: #132133 !important;
}

.crud-table tbody td {
  background-color: #132133 !important;
}

.crud-table .soft-badge {
  display: inline-block;
  white-space: normal;
  padding: 0.5em 0.75em;
  font-size: 0.8rem;
  font-weight: 600;
  line-height: 1.2;
  border-radius: 6px;
  border: 1px solid transparent;
}

.crud-table .soft-badge.badge-danger {
  background-color: rgba(234, 84, 85, 0.12) !important;
  border-color: rgba(234, 84, 85, 0.4);
  color: #d97577 !important;
}

.crud-table .soft-badge.badge-warning {
  background-color: rgba(255, 159, 67, 0.12) !important;
  border-color: rgba(255, 159, 67, 0.4);
  color: #d99a5c !important;
}

.crud-table .soft-badge.badge-success {
  background-color: rgba(40, 199, 111, 0.12) !important;
  border-color: rgba(40, 199, 111, 0.4);
  color: #5cb98a !important;
}

.crud-table .soft-badge.badge-primary {
  background-color: rgba(115, 103, 240, 0.12) !important;
  border-color: rgba(115, 103, 240, 0.4);
  color: #8b82df !important;
}

.crud-table .soft-badge.badge-secondary {
  background-color: rgba(130, 134, 139, 0.12) !important;
  border-color: rgba(130, 134, 139, 0.4);
  color: #a9adb3 !important;
}

.picker-row {
  cursor: pointer;
}

.picker-row:hover td {
  background-color: rgba(115, 103, 240, 0.12) !important;
}

body:not(.dark-layout) .crud-table thead th {
  background-color: rgba(255, 255, 255, 0.45) !important;
}

body:not(.dark-layout) .crud-table tbody tr,
body:not(.dark-layout) .crud-table tbody tr:nth-of-type(odd),
body:not(.dark-layout) .crud-table tbody tr:nth-of-type(even),
body:not(.dark-layout) .crud-table tbody td {
  background-color: rgba(255, 255, 255, 0.35) !important;
}

body:not(.dark-layout) .crud-table .soft-badge.badge-danger { color: #ea5455 !important; }
body:not(.dark-layout) .crud-table .soft-badge.badge-warning { color: #ff9f43 !important; }
body:not(.dark-layout) .crud-table .soft-badge.badge-success { color: #28c76f !important; }
body:not(.dark-layout) .crud-table .soft-badge.badge-primary { color: #7367f0 !important; }

#barcode-scanner-viewport {
  width: 100%;
  min-height: 250px;
}
.zxing-scanner-viewport {
  width: 100%;
  min-height: 250px;
  background: #000;
  object-fit: cover;
}
</style>
